import { z } from "zod";
// Schema for overall dashboard statistics
export const DashboardStatsSchema = z.object({
    // Course stats
    total_courses: z.number().min(0),
    published_courses: z.number().min(0),
    total_modules: z.number().min(0),
    total_exercises: z.number().min(0),
    // User stats
    total_users: z.number().min(0),
    total_students: z.number().min(0),
    total_instructors: z.number().min(0),
    new_users_last_30_days: z.number().min(0),
    active_users_last_7_days: z.number().min(0),
    // Enrollment stats
    total_enrollments: z.number().min(0),
    // Exercise stats
    total_exercises_completed: z.number().min(0),
    average_score: z.number().min(0).max(100),
    // Review stats
    total_reviews: z.number().min(0),
    average_rating: z.number().min(0).max(5),
});
// Schema for enrollment activity over time
export const EnrollmentActivityItemSchema = z.object({
    period: z.string(), // e.g., "2024-W01" for week, "2024-01-15" for day
    label: z.string(), // e.g., "W1", "Mon"
    count: z.number().min(0),
});
export const EnrollmentActivitySchema = z.object({
    period_type: z.enum(["day", "week", "month"]),
    current_period: z.array(EnrollmentActivityItemSchema),
    previous_period: z.array(EnrollmentActivityItemSchema),
    total_current: z.number().min(0),
    total_previous: z.number().min(0),
    growth_percentage: z.number(),
});
// Schema for category distribution
export const CategoryDistributionItemSchema = z.object({
    category: z.string(),
    count: z.number().min(0),
    percentage: z.number().min(0).max(100),
    color: z.string().optional(), // UI hint for chart color
});
export const CategoryDistributionSchema = z.object({
    items: z.array(CategoryDistributionItemSchema),
    total: z.number().min(0),
});
// Schema for top courses
export const TopCourseSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    slug: z.string().nullable(),
    level: z.string(),
    enrolled_count: z.number().min(0),
    completion_rate: z.number().min(0).max(100).optional(),
    average_rating: z.number().min(0).max(5).optional(),
});
export const TopCoursesSchema = z.array(TopCourseSchema);
// Schema for user activity stats (per-period engagement data)
export const ActivityStatItemSchema = z.object({
    label: z.string(),
    current: z.number().min(0),
    previous: z.number().min(0),
    change_percentage: z.number(), // positive = growth, negative = decline
});
export const ActivityStatsSchema = z.object({
    period_type: z.enum(["day", "week", "month"]),
    exercise_attempts: ActivityStatItemSchema,
    exercises_completed: ActivityStatItemSchema,
    words_added: ActivityStatItemSchema,
    learning_sessions: ActivityStatItemSchema,
    course_enrollments: ActivityStatItemSchema,
    reviews_submitted: ActivityStatItemSchema,
});
// Combined dashboard response
export const DashboardDataSchema = z.object({
    stats: DashboardStatsSchema,
    enrollment_activity: EnrollmentActivitySchema.optional(),
    category_distribution: CategoryDistributionSchema.optional(),
    top_courses: TopCoursesSchema.optional(),
});
